// extracted by mini-css-extract-plugin
export default {"largeCard":"TimerCard_largeCard__3ehlV","title":"TimerCard_title__ppc8x","description":"TimerCard_description__om-PO"};